import { Info, HandCoins, Smartphone, CheckCircle2 } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

const STEP_ICONS = [HandCoins, Smartphone, CheckCircle2];

export const GivingDevice = () => {
  const { t } = useLang();
  const g = t.howGiving;
  return (
    <section id="giving" data-testid="how-giving-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>{g.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold text-navy-900 leading-tight">{g.title}</h2>
        </Reveal>

        <div className="mt-10 grid sm:grid-cols-3 gap-4">
          {g.steps.map((label, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <Reveal key={label} delay={i * 0.08} className="h-full">
                <div className="flex sm:flex-col items-center gap-4 rounded-2xl bg-[#FAFAFC] border border-navy-100 p-6 h-full text-left sm:text-center" data-testid={`giving-step-${i}`}>
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl brand-gradient text-navy-900 shadow-md">
                    <Icon size={26} aria-hidden />
                  </span>
                  <div>
                    <p className="text-xs font-bold text-gold-600">{g.step} {i + 1}</p>
                    <p className="mt-0.5 font-display text-base sm:text-lg font-semibold text-navy-900 leading-snug">{label}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 text-center">
            <p className="text-sm font-semibold text-charcoal-700/70">{g.usesTitle}</p>
            <ul className="mt-3 flex flex-wrap justify-center gap-2">
              {g.uses.map((u) => (
                <li key={u} className="rounded-full border border-navy-100 bg-white px-3.5 py-1.5 text-sm text-charcoal-700">{u}</li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 mx-auto max-w-2xl flex gap-3 rounded-2xl bg-cream-subtle border border-navy-100 p-5">
            <Info size={20} className="text-gold-600 shrink-0 mt-0.5" aria-hidden />
            <p className="text-sm text-charcoal-700/80 leading-relaxed" data-testid="giving-device-disclaimer">{g.disclaimer}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
